module.exports = __webpack_public_path__ + "static/media/History_of_Protestantism_vol_3-s.4bff7f26.jpg";